import React from 'react';
import PropTypes from 'prop-types';
import {useMemo, useReducer, useCallback, useEffect} from 'react';

import {MainContext} from './main-context';
import axios from 'axios';
import config from '../../helper/config';
import APIHandler from '../../handlers/APIHandler';
import { questionService } from '../../service/assessment/questionService';


const initialState = {
  loading: false, 
  myAssessments: [],
  gradeCounts: [],
  subjectCounts: [],
  languageCounts: [],
  examCategoryCounts: [],
  reviewerCount:[],
  sourceCounts: [],
  authorCounts: [],
  createdByCounts: [],
  categoryCounts: [],
  difficultyCounts: [],
  chapterCounts: [],
  yearCounts: [],
  termCounts: [],
  statusCounts: [],
  totalCount: 10,
  assmnt_loading: false, 
  assmnt_content:"",
  asmnt_details:"",
  questionContents:[],
  assesment_review:[],
  assessment_operation:[],
  assesment_review_state: null,
  review_loading:false,
  assesment_status_types:[],
  finish_assesment_review:null,
  finalize_paper: null,
  comment_loading:false,
  sub_review_loading: false,
  assesment_sub_review_state:null,
  assesment_mark_as_review_state:null,
  mark_as_review_loading:false,
  assign_reviewer:null,
  assign_operator:null,
  assignment_background_loading:false,
  operation_comment_loading:false,

  addTemplate:null,
  templates:[],
  updateTemplate:null,
  templateMetaData:null,
  addSection:null,
  sections:[],
  updateSection:null,
  addPart:null,
  parts:[],
  updatePart:null,

  student_dashboard_data: null,
  student_dashboard_data_loading: false,
  student_dashboard_initial_loading: true,

  parent_dashboard_data: null,
  parent_dashboard_data_loading: false,
  parent_dashboard_initial_loading:true,

  assesor_dashboard_data:null,
  assesor_dashboard_data_loading:false,
  assesor_dashboard_initial_loading:true,

  reviewer_dashboard_initial_loading:true,
  reviewer_dashboard_data_loading:false,
  reviewer_dashboard_data:null,

  assessment_filter_data_initial_loading:true,
  assessment_filter_data_loading:false,
  assessment_filter_data: [],
  

};


const reducer = (state, action) => {

  switch (action.type) {

    case 'INITIAL':
      return {
        loading: false,
        myAssessments:[],
        totalCount: 10,
        gradeCounts: [],
        subjectCounts: [],
        languageCounts: [],
        examCategoryCounts: [],
        reviewerCount:[],
        sourceCounts: [],
        authorCounts: [],
        createdByCounts: [],
        categoryCounts: [],
        difficultyCounts: [],
        chapterCounts: [],
        yearCounts: [],
        termCounts: [],
        statusCounts: [],
        assmnt_loading: false, 
        assmnt_content:"",
        asmnt_details:"",
        questionContents:[],
        assesment_review:[],
        assessment_operation:[],
        assesment_review_state:null,
        review_loading: false,
        assesment_status_types:[],
        finish_assesment_review:null,
        finalize_paper: null,
        comment_loading:false,
        sub_review_loading:false,
        assesment_sub_review_state:null,
        assesment_mark_as_review_state:null,
        mark_as_review_loading:false,
        assign_reviewer:null,
        assign_operator:null,
        assignment_background_loading:false,
        templates:[],
        addTemplate:null,
        updateTemplate:null,
        templateMetaData:null,
        addSection:null,
        sections:[],
        updateSection:null,
        addPart:null,
        parts:[],
        updatePart:null,
        operation_comment_loading:false,

        student_dashboard_data:null,
        student_dashboard_data_loading:false,
        student_dashboard_initial_loading: true,

        parent_dashboard_data:null,
        parent_dashboard_data_loading:false,
        parent_dashboard_initial_loading:true,

        assesor_dashboard_data:null,
        assesor_dashboard_data_loading:false,
        assesor_dashboard_initial_loading:true,

        reviewer_dashboard_initial_loading:true,
        reviewer_dashboard_data_loading:false,
        reviewer_dashboard_data:null,

        assessment_filter_data_initial_loading:true,
        assessment_filter_data_loading:false,
        assessment_filter_data: [],
      }

    case 'SET_LOADING':
      return { 
        ...state, 
        loading: action.payload.loading 
      };

    case 'SET_MY_ASSESSMENTS':
      return { 
        ...state, 
        myAssessments: action.payload.myAssessments,
        totalCount: action.payload.totalCount,
        gradeCounts: action.payload.gradeCounts,
        subjectCounts: action.payload.subjectCounts,
        languageCounts: action.payload.languageCounts,
        examCategoryCounts: action.payload.examCategoryCounts,
        reviewerCount: action.payload.reviewerCount,
        sourceCounts: action.payload.sourceCounts,
        authorCounts: action.payload.authorCounts,
        categoryCounts: action.payload.categoryCounts,
        difficultyCounts: action.payload.difficultyCounts,
        chapterCounts: action.payload.chapterCounts,
        yearCounts: action.payload.yearCounts,
        termCounts: action.payload.termCounts,
        statusCounts: action.payload.statusCounts,
        createdByCounts: action.payload.createdByCounts,
        assesment_status_types: action.payload.assesment_status_types
      };

    case 'SET_ASSESMENTCONTENT_LOADING':
      return { 
        ...state, 
        assmnt_loading: action.payload.assmnt_loading 
      };

    case 'SET_ASSESMENTCONTENT_CONTENT':
      return { 
        ...state, 
        assmnt_content: action.payload.assmnt_content
      };

    case 'SET_ASSESMENT_DETAILS':
      return { 
        ...state, 
        asmnt_details: action.payload.asmnt_details
      };

    case 'SET_ASSESMENTCONTENT_BLOB_CONTENT':
      return { 
        ...state, 
        questionContents: action.payload.questionContents 
      };

    case 'ADD_UPDATE_REVIEW_STATE':
      return { 
        ...state, 
        assesment_review_state: action.payload.assesment_review_state 
      };

    case 'SET_ASSESMENT_REVIEWS':
      return { 
        ...state, 
        assesment_review: action.payload.assesment_review 
      };

    case 'SET_ADD_UPDATE_REVIEW_LOADING':
      return { 
          ...state, 
          review_loading: action.payload.review_loading 
      };

    case 'SET_ASSESMENT_OPERATIONS':
      return { 
        ...state, 
        assessment_operation: action.payload.assessment_operation 
      };

    case 'FINISH_ASSESMENT_REVIEWS':
      return { 
        ...state, 
        finish_assesment_review: action.payload.finish_assesment_review 
      };

    case 'FINALIZE_PAPER':
      return { 
        ...state, 
        finalize_paper: action.payload.finalize_paper 
      };

    case 'COMMENT_LOADING':
      return { 
        ...state, 
        comment_loading: action.payload.comment_loading 
      };

    case 'SET_ADD_UPDATE_SUB_REVIEW_LOADING':
      return { 
        ...state, 
        sub_review_loading: action.payload.sub_review_loading 
      };

    case 'ADD_UPDATE_SUB_REVIEW_STATE':
      return { 
        ...state, 
        assesment_sub_review_state: action.payload.assesment_sub_review_state 
      };

    case 'MARK_AS_REVIEW_STATE':
      return { 
        ...state, 
        assesment_mark_as_review_state: action.payload.assesment_mark_as_review_state 
      };

    case 'SET_ADD_UPDATE_MARK_AS_REVIEW_LOADING':
      return { 
        ...state, 
        mark_as_review_loading: action.payload.mark_as_review_loading 
      };

    case 'ASSIGN_REVIEWER':
      return { 
        ...state, 
        assign_reviewer: action.payload.assign_reviewer 
      };

    case 'ASSIGN_OPERATOR':
      return { 
        ...state, 
        assign_operator: action.payload.assign_operator 
      };

    case 'ASSESSMENT_BACKGROUND_FETCH_LOADING':
      return { 
        ...state, 
        assignment_background_loading: action.payload.assignment_background_loading 
      };

    case 'SET_TEMPLATES':
      return { 
        ...state, 
        templates: action.payload.templates 
      };
    case 'ADD_TEMPLATE':
      return { 
        ...state, 
        addTemplate: action.payload.addTemplate 
      };
    case 'UPDATE_TEMPLATE':
      return { 
        ...state, 
        updateTemplate: action.payload.updateTemplate 
      };
    case 'UPDATE_TEMPLATE_IN_LIST':
      return {
        ...state,
        templates: {
          ...state.templates,
          data: {
            ...state.templates.data,
            templates: state.templates.data.templates.map(template => 
              template.template_id === action.payload.templateId ? 
              {...template, ...action.payload.updatedFields} 
              : 
              template
            )
          }
        }
      };
    case 'SET_TEMPLATE_META_DATA':
      return { 
        ...state, 
        templateMetaData: action.payload.templateMetaData 
      };
    case 'ADD_SECTION':
      return { 
        ...state, 
        addSection: action.payload.addSection 
      };
    case 'SET_SECTIONS':
      return { 
        ...state, 
        sections: action.payload.sections 
      };
    case 'UPDATE_SECTION':
      return { 
        ...state, 
        updateSection: action.payload.updateSection 
      };
    case 'ADD_PART':
      return { 
        ...state, 
        addPart: action.payload.addPart 
      };
    case 'SET_PARTS':
      return { 
        ...state, 
        parts: action.payload.parts 
      };
    case 'UPDATE_PART':
      return { 
        ...state, 
        updatePart: action.payload.updatePart 
      };
    case 'OPERATION_COMMENT_LOADING':
      return { 
        ...state, 
        operation_comment_loading: action.payload.operation_comment_loading 
      };

    case 'SET_STUDENT_DASHBOARD_DATA':
      return { 
        ...state, 
        student_dashboard_data: action.payload.student_dashboard_data 
      };
    case 'SET_STUDENT_DASHBOARD_DATA_LOADING':
      return { 
        ...state, 
        student_dashboard_data_loading: action.payload.student_dashboard_data_loading 
      };
    case 'SET_STUDENT_DASHBOARD_INITIAL_LOADING':
      return { 
        ...state, 
        student_dashboard_initial_loading: action.payload.student_dashboard_initial_loading 
      };
    case 'SET_PARENT_DASHBOARD_DATA':
      return { 
        ...state, 
        parent_dashboard_data: action.payload.parent_dashboard_data 
      };
    case 'SET_PARENT_DASHBOARD_DATA_LOADING':
      return { 
        ...state, 
        parent_dashboard_data_loading: action.payload.parent_dashboard_data_loading 
      };
    case 'SET_PARENT_DASHBOARD_INITIAL_LOADING':
      return { 
        ...state, 
        parent_dashboard_initial_loading: action.payload.parent_dashboard_initial_loading 
      };

    case 'SET_ASSESOR_DASHBOARD_DATA':
      return { 
        ...state, 
        assesor_dashboard_data: action.payload.assesor_dashboard_data 
      };
    case 'SET_ASSESOR_DASHBOARD_DATA_LOADING':
      return { 
        ...state, 
        assesor_dashboard_data_loading: action.payload.assesor_dashboard_data_loading 
      };
    case 'SET_ASSESOR_DASHBOARD_INITIAL_LOADING':
      return { 
        ...state, 
        assesor_dashboard_initial_loading: action.payload.assesor_dashboard_initial_loading 
      };
    case 'SET_REVIEWER_DASHBOARD_DATA':
      return { 
        ...state, 
        reviewer_dashboard_data: action.payload.reviewer_dashboard_data 
      };
    case 'SET_REVIEWER_DASHBOARD_DATA_LOADING':
      return { 
        ...state, 
        reviewer_dashboard_data_loading: action.payload.reviewer_dashboard_data_loading 
      };
    case 'SET_REVIEWER_DASHBOARD_DATA_INITIAL_LOADING':
      return { 
        ...state, 
        reviewer_dashboard_initial_loading: action.payload.reviewer_dashboard_initial_loading 
      };
    
    case 'SET_ASSESSMENT_FILTER_DATA':
      return { 
        ...state, 
        assessment_filter_data: action.payload.assessment_filter_data 
      };
    case 'SET_ASSESSMENT_FILTER_DATA_LOADING':
      return { 
        ...state, 
        assessment_filter_data_loading: action.payload.assessment_filter_data_loading 
      };
    case 'SET_ASSESSMENT_FILTER_DATA_INITIAL_LOADING':
      return { 
        ...state, 
        assessment_filter_data_initial_loading: action.payload.assessment_filter_data_initial_loading 
      };
    default:
      return state;
  }
};

// ----------------------------------------------------------------------

export function MainContextProvider({children}) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const initialize = useCallback(async () => {
    
    dispatch({
      type: 'INITIAL',
      payload: {
        myAssessments:[],
        gradeCounts: [],
        subjectCounts: [],
        languageCounts: [],
        examCategoryCounts: [],
        reviewerCount:[],
        sourceCounts: [],
        authorCounts: [],
        createdByCounts: [],
        categoryCounts: [],
        difficultyCounts: [],
        chapterCounts: [],
        yearCounts: [],
        termCounts: [],
        statusCounts: [],
        loading:false,
        totalCount: 10,
        assmnt_loading: false, 
        assmnt_content:"",
        asmnt_details:"",
        questionContents:[],
        assesment_review:[],
        assessment_operation:[],
        assesment_review_state:null,
        review_loading: false,
        assesment_status_types:[],
        finish_assesment_review:null,
        finalize_paper: null,
        comment_loading: false,
        sub_review_loading:false,
        assesment_sub_review_state:null,
        assesment_mark_as_review_state:null,
        mark_as_review_loading:false,
        assign_reviewer:null,
        assign_operator:null,
        assignment_background_loading:false,
        templates:[],
        addTemplate:null,
        templateMetaData:null,
        addSection:null,
        sections:[],
        updateSection:null,
        addPart:null,
        parts:[],
        updatePart:null,
        operation_comment_loading:false,

        student_dashboard_data:null,
        student_dashboard_data_loading:false,
        student_dashboard_initial_loading: true,

        parent_dashboard_data:null,
        parent_dashboard_data_loading:false,
        parent_dashboard_initial_loading:true,

        assesor_dashboard_data:null,
        assesor_dashboard_data_loading:false,
        assesor_dashboard_initial_loading:true,

        reviewer_dashboard_initial_loading:true,
        reviewer_dashboard_data_loading:false,
        reviewer_dashboard_data:null,

        assessment_filter_data_initial_loading:true,
        assessment_filter_data_loading:false,
        assessment_filter_data: [],
      },
    });

  }, []);
 
  useEffect(() => {
    initialize();
  }, [initialize]);

    
  const fetchAllMyAssessments = useCallback(
    async (
      filterOptions,
      employeeType,
      user_id,
      staff_user_id,
      limit,
      offset,
      sort_column,
      sort_direction,
      search_term,
      selectedCategories,
      selectedAuthors,
      selectedChapters,
      selectedGrades,
      selectedDifficulties,
      selectedLanguages,
      selectedTerms,
      selectedYears,
      selectedsubjects,
      selectedStatuses,
      selectedExamCategories,
      selectedStartDate,
      selectedEndDate,
      assign_reviewer,
      assign_operator,  
      selectedReviewers

    ) => {
      
      if(assign_reviewer){
        dispatch({ type: 'ASSESSMENT_BACKGROUND_FETCH_LOADING', payload: { assignment_background_loading: true } });
      }
      if(assign_operator){
        dispatch({ type: 'ASSESSMENT_BACKGROUND_FETCH_LOADING', payload: { assignment_background_loading: true } });
      }
      else{
        dispatch({ type: 'SET_LOADING', payload: { loading: true } });
      }
      
      try {
        // Construct the query string manually
        const queryParams = new URLSearchParams({
          limit,
          offset,
          sort_column,
          sort_direction,
          search_term,
          selectedCategories: selectedCategories || null,
          selectedAuthors: selectedAuthors || null,
          selectedChapters: selectedChapters || null,
          selectedGrades: selectedGrades || null,
          selectedDifficulties: selectedDifficulties || null,
          selectedLanguages: selectedLanguages || null,
          selectedTerms: selectedTerms || null,
          selectedYears: selectedYears || null,
          selectedsubjects: selectedsubjects || null,
          selectedStatuses: selectedStatuses || null,
          selectedExamCategories: selectedExamCategories || null,
          selectedStartDate: selectedStartDate || null,
          selectedEndDate: selectedEndDate || null,
          selectedReviewers: selectedReviewers || null,
        }).toString();

        const url = `${config.oat_api_url}/assessments/getAllFilteredMyAssessmentsReview/managed?${queryParams}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          body: JSON.stringify({ 
            user_id, 
            staff_user_id, 
            employeeType, 
            filterOptions 
          }),
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const data = await response.json();
  
        const { 
          assessments, 
          total_count, 
          assesment_status_types,
          grade_counts,
          subject_counts,
          language_counts,
          exam_category_counts,
          source_counts,
          author_counts,
          category_counts,
          difficulty_counts,
          chapter_counts,
          year_counts,
          term_counts,
          status_counts,
          created_by_counts,
          reviewer_count
        } = data.data;
  
        dispatch({
          type: 'SET_MY_ASSESSMENTS',
          payload: { 
            myAssessments: assessments,
            totalCount: total_count, 
            gradeCounts: grade_counts,
            subjectCounts: subject_counts,
            languageCounts: language_counts,
            examCategoryCounts: exam_category_counts,
            sourceCounts: source_counts,
            authorCounts: author_counts,
            categoryCounts: category_counts,
            difficultyCounts: difficulty_counts,
            chapterCounts: chapter_counts,
            yearCounts: year_counts,
            termCounts: term_counts,
            statusCounts: status_counts,
            createdByCounts: created_by_counts,
            assesment_status_types: assesment_status_types,
            reviewerCount: reviewer_count
          },
        });
      } catch (error) {
        console.error('Error fetching assessments:', error);
      } finally {
        dispatch({ type: 'SET_LOADING', payload: { loading: false } });
        dispatch({ type: 'ASSESSMENT_BACKGROUND_FETCH_LOADING', payload: { assignment_background_loading: false } });
        dispatch({ type: 'ASSIGN_REVIEWER', payload: { assign_reviewer: null } });
        dispatch({ type: 'ASSIGN_OPERATOR', payload: { assign_operator: null } });
      }
    },
    []
  );

  const fetchLoadAssesmentQuestionById = useCallback(
    async (assessment_id) => {

      dispatch({ type: 'SET_ASSESMENTCONTENT_LOADING', payload: { assmnt_loading: true } });
  
      try {

  
        const url = `${config.oat_api_url}/assessment/questions/getAllQuestions/${assessment_id}`;
  
        const requestOptions = {
          method: 'GET',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const data = await response.json();
  
        const { examQuestions, assessment_details } = data.data; 

        const parsedExamQuestions = JSON.parse(examQuestions);
  
        dispatch({
          type: 'SET_ASSESMENTCONTENT_CONTENT',
          payload: { 
            assmnt_content: parsedExamQuestions.questions
          },
        });

        dispatch({
          type: 'SET_ASSESMENT_DETAILS',
          payload: { 
            asmnt_details: assessment_details
          },
        });

      } catch (error) {
        console.error('Error fetching assessment content:', error);
      } finally {
        dispatch({ type: 'SET_ASSESMENTCONTENT_LOADING', payload: { assmnt_loading: false } });
      }
    },
    []
  );

  const getAllQuestionContents = useCallback(
    async (questions) => {

      try{

        let fetchQuestions = await questionService.getAllQuestionContents({ questions: questions })

        dispatch({
          type: 'SET_ASSESMENTCONTENT_BLOB_CONTENT',
          payload: { 
            questionContents: fetchQuestions 
          },
        });

          
      } catch (error) {
          console.error("Failed to get assesment content blob: ", error)
      }

    },
    []
  );

  const addUpdateReviewForAssesment = useCallback(
    async (review_array, assessment_id) => {

  
      try {

        dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: true } });
        dispatch({ type: 'COMMENT_LOADING', payload: { comment_loading: true } });

        const url = `${config.oat_api_url}/assessments/add_or_update_review/${assessment_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            'Content-Type': 'application/json', 
          },
          body: JSON.stringify({ reviews: review_array }), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const res_data = await response.json();
  

        const assesment_review_state = res_data
        
  
        dispatch({
          type: 'ADD_UPDATE_REVIEW_STATE',
          payload: { 
            assesment_review_state: assesment_review_state
          },
        });

      } catch (error) {
        console.error('Error fetching assessment content:', error);
      } finally {
        dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: false } });
        dispatch({ type: 'COMMENT_LOADING', payload: { comment_loading: false } });
        setTimeout(() => {
          dispatch({
            type: 'ADD_UPDATE_REVIEW_STATE',
            payload: { 
              assesment_review_state: null 
            },
          });
        }, 2000);
      }
      
    },
    []
  );

  const fetchAllReviewComments = useCallback(
    async (assessment_id) => {

      dispatch({ type: 'COMMENT_LOADING', payload: { comment_loading: true } });
      dispatch({ type: 'SET_ADD_UPDATE_SUB_REVIEW_LOADING', payload: { sub_review_loading: true } });
  
      try {

  
        const url = `${config.oat_api_url}/assessments/get_all_reviews_by_id/${assessment_id}`;
  
        const requestOptions = {
          method: 'GET',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const res_data = await response.json();
  
        const {data, success, message} = res_data;
  
        dispatch({
          type: 'SET_ASSESMENT_REVIEWS',
          payload: { 
            assesment_review: data 
          },
        });

      } catch (error) {
        console.error('Error fetching assessment reviews:', error);
      } finally {
        dispatch({ type: 'COMMENT_LOADING', payload: { comment_loading: false } });
        dispatch({ type: 'SET_ADD_UPDATE_SUB_REVIEW_LOADING', payload: { sub_review_loading: false } });
      }
    },
    []
  );

  const fetchAllOperationComments = useCallback(
    async (assessment_id) => {

      dispatch({ type: 'OPERATION_COMMENT_LOADING', payload: { operation_comment_loading: true } });
  
      try {

  
        const url = `${config.oat_api_url}/assessments/get_all_operations_by_id/${assessment_id}`;
  
        const requestOptions = {
          method: 'GET',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const res_data = await response.json();
  
        const {data, success, message} = res_data;
  
        dispatch({
          type: 'SET_ASSESMENT_OPERATIONS',
          payload: { 
            assessment_operation: data 
          },
        });

      } catch (error) {
        console.error('Error fetching assessment operation comments:', error);
      } finally {
        dispatch({ type: 'OPERATION_COMMENT_LOADING', payload: { operation_comment_loading: false } });
      }
    },
    []
  );

  const finishPaperReview = useCallback(
    async (selectedStatus,assessment_id,reviewer_id,asmnt_review_id) => {

      dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: true } });
  
      try {

  
        const url = `${config.oat_api_url}/assessments/finish_review_by_id/${assessment_id}/${reviewer_id}/${asmnt_review_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          body: JSON.stringify({ assessment_state: selectedStatus }), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const res_data = await response.json();

        dispatch({
          type: 'FINISH_ASSESMENT_REVIEWS',
          payload: { 
            finish_assesment_review: res_data 
          },
        });

      } catch (error) {
        console.error('Error finishing assessment reviews:', error);
      } finally {
        dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: false } });

        setTimeout(() => {
          dispatch({
            type: 'FINISH_ASSESMENT_REVIEWS',
            payload: { 
              finish_assesment_review: null 
            },
          });
        }, 2000);
      }
    },
    []
  );

  const setReview = useCallback(
    async (selectedStatus,assessment_id,reviewer_id,asmnt_review_id) => {

      dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: true } });
  
      try {
  
        const url = `${config.oat_api_url}/assessments/set_review_by_id/${assessment_id}/${reviewer_id}/${asmnt_review_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          body: JSON.stringify({ assessment_state: selectedStatus }), 
        };
  
        const response = await fetch(url, requestOptions);

        const result_data = await APIHandler.handleResponse(response);

        if (!result_data.success || result_data.status === 400) {
          dispatch({ type: 'ASSIGN_REVIEWER', payload: { assign_reviewer: result_data } });
          return result_data;
        }

        return result_data;

      } catch (error) {
        console.error('Error setting for review:', error);
      } finally {
        dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: false } });
      }
    },
    []
  );

  const finishPaperOperation = useCallback(
    async (currentAssessmentStatusId,assessment_id,employee_id,asmnt_operation_id) => {

      dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: true } });
  
      try {

  
        const url = `${config.oat_api_url}/assessments/finish_operation_by_id/${assessment_id}/${employee_id}/${asmnt_operation_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          body: JSON.stringify({ operation_id: currentAssessmentStatusId }), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const res_data = await response.json();

        dispatch({
          type: 'FINISH_ASSESMENT_REVIEWS',
          payload: { 
            finish_assesment_review: res_data 
          },
        });

      } catch (error) {
        console.error('Error finishing assessment reviews:', error);
      } finally {
        dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: false } });

        setTimeout(() => {
          dispatch({
            type: 'FINISH_ASSESMENT_REVIEWS',
            payload: { 
              finish_assesment_review: null 
            },
          });
        }, 2000);
      }
    },
    []
  );

  const finalizePaper = useCallback(
    async (assessment_id,asmnt_review_id,reviewer_id) => {

      dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: true } });
  
      try {

  
        const url = `${config.oat_api_url}/assessments/finalize_paper_by_id/${assessment_id}/${asmnt_review_id}/${reviewer_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const res_data = await response.json();
    
        dispatch({
          type: 'FINALIZE_PAPER',
          payload: { 
            finalize_paper: res_data 
          },
        });

      } catch (error) {
        console.error('Error finishing assessment reviews:', error);
      } finally {
        dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: false } });
      }
    },
    []
  );
  
  const addSubReviewForAssesment = useCallback(
    async (review, assessment_id) => {

  
      try {

        dispatch({ type: 'SET_ADD_UPDATE_SUB_REVIEW_LOADING', payload: { sub_review_loading: true } });

        const url = `${config.oat_api_url}/assessments/add_sub_review/${assessment_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            'Content-Type': 'application/json', 
          },
          body: JSON.stringify({ review: review }), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const res_data = await response.json();
  

        const assesment_review_state = res_data
        
  
        dispatch({
          type: 'ADD_UPDATE_SUB_REVIEW_STATE',
          payload: { 
            assesment_sub_review_state: assesment_review_state
          },
        });


      } catch (error) {
        console.error('Error fetching assessment content:', error);
      } finally {
          dispatch({ type: 'SET_ADD_UPDATE_SUB_REVIEW_LOADING', payload: { sub_review_loading: false } });
          
          setTimeout(() => {
            dispatch({
              type: 'ADD_UPDATE_SUB_REVIEW_STATE',
              payload: { 
                assesment_sub_review_state: null, 
              },
            });
          }, 2000);
      }
      
    },
    []
  );

  const addOperationCommentForAssessment = useCallback(
    async (review, assessment_id) => {

  
      try {

        dispatch({ type: 'SET_ADD_UPDATE_SUB_REVIEW_LOADING', payload: { sub_review_loading: true } });

        const url = `${config.oat_api_url}/assessments/add_sub_operation_comment/${assessment_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            'Content-Type': 'application/json', 
          },
          body: JSON.stringify({ review: review }), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const res_data = await response.json();
  

        const assesment_review_state = res_data
        
  
        dispatch({
          type: 'ADD_UPDATE_SUB_REVIEW_STATE',
          payload: { 
            assesment_sub_review_state: assesment_review_state
          },
        });


      } catch (error) {
        console.error('Error fetching assessment content:', error);
      } finally {
          dispatch({ type: 'SET_ADD_UPDATE_SUB_REVIEW_LOADING', payload: { sub_review_loading: false } });
          
          setTimeout(() => {
            dispatch({
              type: 'ADD_UPDATE_SUB_REVIEW_STATE',
              payload: { 
                assesment_sub_review_state: null, 
              },
            });
          }, 2000);
      }
      
    },
    []
  );

  const markAsReviewForQuestion = useCallback(
    async (review, assessment_id) => {

      try {

        dispatch({ type: 'SET_ADD_UPDATE_MARK_AS_REVIEW_LOADING', payload: { mark_as_review_loading: true } });

        const url = `${config.oat_api_url}/assessments/mark_as_reviewd/${assessment_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            'Content-Type': 'application/json', 
          },
          body: JSON.stringify({ review: review }), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const res_data = await response.json();
  

        const assesment_mark_as_review_state = res_data
        
  
        dispatch({
          type: 'MARK_AS_REVIEW_STATE',
          payload: { 
            assesment_mark_as_review_state: assesment_mark_as_review_state
          },
        });


      } catch (error) {
        console.error('Error fetching mark as review:', error);
        dispatch({
          type: 'MARK_AS_REVIEW_STATE',
          payload: { 
            assesment_mark_as_review_state: {
              success:'false',
              message:'Failed to make as review the question',
              data:null,
            }
          },
        });
      } finally {
          dispatch({ type: 'SET_ADD_UPDATE_MARK_AS_REVIEW_LOADING', payload: { mark_as_review_loading: false } });
          
          setTimeout(() => {
            dispatch({
              type: 'MARK_AS_REVIEW_STATE',
              payload: { 
                assesment_mark_as_review_state: null
              },
            });
          }, 2000);
      }
      
    },
    []
  );

  const setLoadings = (name,state,value)=>{
    dispatch({ type: name, payload: { state: value } });
  }

  const assignReviewer = useCallback(
    async (selectedReviewer,assessment_id,assign_by) => {


      try {


        const url = `${config.oat_api_url}/assessments/assign_reviewer_to_paper/${assessment_id}/${assign_by}`;

        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          body: JSON.stringify({ selected_reviewer: selectedReviewer }), 
        };

        const response = await fetch(url, requestOptions);

        const result_data = await APIHandler.handleResponse(response);

        if (!result_data.success || result_data.status === 400) {
          dispatch({ type: 'ASSIGN_REVIEWER', payload: { assign_reviewer: result_data } });
          return result_data;
        }

        return result_data;

      } catch (error) {
        dispatch({ type: 'ASSIGN_REVIEWER', payload: { assign_reviewer: null } });
        console.error('Error assign reviewer :', error);
      }
    },[]);

  const changeAssignedReviewer = useCallback(
    async (selectedReviewer,selectedAssessmentReviewId,assign_by) => {

      try {

        const url = `${config.oat_api_url}/assessments/change_reviewer_to_paper/${selectedAssessmentReviewId}/${assign_by}`;

        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          body: JSON.stringify({ selected_reviewer: selectedReviewer }), 
        };

        const response = await fetch(url, requestOptions);

        const result_data = await APIHandler.handleResponse(response);

        if (!result_data.success || result_data.status === 400) {
          return result_data;
        }

        return result_data;

    } catch (error) {
      console.error('Error changing assigned reviewer :', error);
    }
  },[]);

  const assignOperator = useCallback(
    async (selectedOperator,assessment_id,assign_by,selectedOperation) => {

      try {

        const url = `${config.oat_api_url}/assessments/assign_operator_to_paper/${assessment_id}/${assign_by}`;

        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          body: JSON.stringify({ selected_operator: selectedOperator, selected_operation: selectedOperation }), 
        };

        const response = await fetch(url, requestOptions);

        const result_data = await APIHandler.handleResponse(response);

        if (!result_data.success || result_data.status === 400) {
          dispatch({ type: 'ASSIGN_OPERATOR', payload: { assign_operator: result_data } });
          return result_data;
        }

        return result_data;

    } catch (error) {
      dispatch({ type: 'ASSIGN_OPERATOR', payload: { assign_operator: null } });
      console.error('Error assign operator :', error);
    }
  },[]);

  const changeAssignedOperator = useCallback(
    async (selectedOperator,selectedAssessmentOperationId,assign_by) => {

      try {

        const url = `${config.oat_api_url}/assessments/change_operator_to_paper/${selectedAssessmentOperationId}/${assign_by}`;

        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          body: JSON.stringify({ selected_operator: selectedOperator }), 
        };

        const response = await fetch(url, requestOptions);

        const result_data = await APIHandler.handleResponse(response);

        if (!result_data.success || result_data.status === 400) {
          return result_data;
        }

        return result_data;

    } catch (error) {
      console.error('Error changing assigned operator :', error);
    }
  },[]);

  const createTemplate = useCallback(
    async (newTemplate,user_id) => {

  
      try {

  
        const url = `${config.oat_api_url}/manage/template/add/${user_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
           body: JSON.stringify(newTemplate), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const addTemplate = await APIHandler.handleResponse(response);
    
        dispatch({
          type: 'ADD_TEMPLATE',
          payload: { 
            addTemplate: addTemplate 
          },
        });

        setTimeout(() => {
          dispatch({
          type: 'ADD_TEMPLATE',
          payload: { 
            addTemplate: null 
          },
        });
        }, 3000);

      } catch (error) {
        console.error('Error fetching templates:', error);
      }
    },
    []
  );

  const fetchAllTemplates = useCallback(
    async (limit, offset, sort_column, sort_direction, user_id) => {

  
      try {

        const queryParams = new URLSearchParams({
          limit,
          offset,
          sort_column,
          sort_direction,
          user_id,
        }).toString();


  
        const url = `${config.oat_api_url}/manage/template/getAll?${queryParams}`;
  
        const requestOptions = {
          method: 'GET',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const templates = await APIHandler.handleResponse(response);

        dispatch({
          type: 'SET_TEMPLATES',
          payload: { 
            templates: templates 
          },
        });

      } catch (error) {
        console.error('Error fetching templates:', error);
      }
    },
    []
  );

  const handleUpdateTemplate = useCallback(
    async (updateTemplate,user_id, template_id) => {

  
      try {

  
        const url = `${config.oat_api_url}/manage/template/update/${user_id}/${template_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          body: JSON.stringify(updateTemplate), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const updatedTemplate = await APIHandler.handleResponse(response);
        
        if(updatedTemplate && updatedTemplate.success){

           dispatch({
            type: 'UPDATE_TEMPLATE',
            payload: { 
              updateTemplate: updatedTemplate 
            },
          });

          dispatch({
            type: 'UPDATE_TEMPLATE_IN_LIST',
            payload: {
              templateId: template_id,
              updatedFields: updatedTemplate.data
            }
          });

        }
        else{
          dispatch({
            type: 'UPDATE_TEMPLATE',
            payload: { 
              updateTemplate: {'success':false} 
            },
          });
        }
    
        setTimeout(() => {
          dispatch({
          type: 'UPDATE_TEMPLATE',
          payload: { 
            updateTemplate: null 
          },
        });
        }, 3000);

      } catch (error) {
        console.error('Error fetching templates:', error);
      }
    },
    [state.templates]
  );

  const fetchTemplateMetaData = useCallback(
    async () => {

  
      try {
  
        const url = `${config.oat_api_url}/manage/template/getMetaData`;
  
        const requestOptions = {
          method: 'GET',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const metadata = await APIHandler.handleResponse(response);

        dispatch({
          type: 'SET_TEMPLATE_META_DATA',
          payload: { 
            templateMetaData: metadata.data 
          },
        });

      } catch (error) {
        console.error('Error fetching metadata:', error);
      }
    },
    []
  );

  const createSection = useCallback(
    async (newSection,user_id) => {

  
      try {

  
        const url = `${config.oat_api_url}/manage/template/add-section/${user_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
           body: JSON.stringify(newSection), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const addSection = await APIHandler.handleResponse(response);
    
        dispatch({
          type: 'ADD_SECTION',
          payload: { 
            addSection: addSection
          },
        });

        setTimeout(() => {
          dispatch({
          type: 'ADD_SECTION',
          payload: { 
            addSection: null 
          },
        });
        }, 3000);

      } catch (error) {
        console.error('Error fetching sections:', error);
      }
    },
    []
  );

  const fetchAllSections = useCallback(
    async (limit, offset, sort_column, sort_direction, user_id) => {

  
      try {

        const queryParams = new URLSearchParams({
          limit,
          offset,
          sort_column,
          sort_direction,
          user_id,
        }).toString();


  
        const url = `${config.oat_api_url}/manage/template/get-all-sections?${queryParams}`;
  
        const requestOptions = {
          method: 'GET',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const sections = await APIHandler.handleResponse(response);

        dispatch({
          type: 'SET_SECTIONS',
          payload: { 
            sections: sections 
          },
        });

      } catch (error) {
        console.error('Error fetching templates:', error);
      }
    },
    []
  );

  const handleUpdateSection = useCallback(
    async (updateSection,user_id, section_id) => {

  
      try {

  
        const url = `${config.oat_api_url}/manage/template/update-section/${user_id}/${section_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          body: JSON.stringify(updateSection), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const updateSectionRes = await APIHandler.handleResponse(response);
        
        if(updateSectionRes && updateSectionRes.success){

           dispatch({
            type: 'UPDATE_SECTION',
            payload: { 
              updateSection: updateSectionRes
            },
          });

        }
        else{
          dispatch({
            type: 'UPDATE_SECTION',
            payload: { 
              updateSection: {'success':false} 
            },
          });
        }
    
        setTimeout(() => {
          dispatch({
          type: 'UPDATE_SECTION',
          payload: { 
            updateSection: null 
          },
        });
        }, 3000);

      } catch (error) {
        console.error('Error fetching sections:', error);
      }
    },
    [state.sections]
  );

  const createPart = useCallback(
    async (newPart,user_id) => {

  
      try {

  
        const url = `${config.oat_api_url}/manage/template/add-part/${user_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
           body: JSON.stringify(newPart), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const addPart = await APIHandler.handleResponse(response);
    
        dispatch({
          type: 'ADD_PART',
          payload: { 
            addPart: addPart 
          },
        });

        setTimeout(() => {
          dispatch({
          type: 'ADD_PART',
          payload: { 
            addPart: null 
          },
        });
        }, 3000);

      } catch (error) {
        console.error('Error adding part:', error);
      }
    },
    []
  );

  const fetchAllParts = useCallback(
    async (limit, offset, sort_column, sort_direction, user_id) => {

  
      try {

        const queryParams = new URLSearchParams({
          limit,
          offset,
          sort_column,
          sort_direction,
          user_id,
        }).toString();


  
        const url = `${config.oat_api_url}/manage/template/get-all-parts?${queryParams}`;
  
        const requestOptions = {
          method: 'GET',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const parts = await APIHandler.handleResponse(response);

        dispatch({
          type: 'SET_PARTS',
          payload: { 
            parts: parts 
          },
        });

      } catch (error) {
        console.error('Error fetching parts:', error);
      }
    },
    []
  );

  const handleUpdatePart = useCallback(
    async (updatePart,user_id, part_id) => {

  
      try {

  
        const url = `${config.oat_api_url}/manage/template/update-part/${user_id}/${part_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          body: JSON.stringify(updatePart), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const updatePartRes = await APIHandler.handleResponse(response);
        
        if(updatePartRes && updatePartRes.success){

           dispatch({
            type: 'UPDATE_PART',
            payload: { 
              updatePart: updatePartRes
            },
          });

        }
        else{
          dispatch({
            type: 'UPDATE_PART',
            payload: { 
              updatePart: {'success':false} 
            },
          });
        }
    
        setTimeout(() => {
          dispatch({
          type: 'UPDATE_PART',
          payload: { 
            updatePart: null 
          },
        });
        }, 3000);

      } catch (error) {
        console.error('Error update part:', error);
      }
    },
    [state.sections]
  );

  const finishPaperReviewByCompleted = useCallback(
    async (assessment_id,reviewer_id,asmnt_review_id) => {

      dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: true } });
  
      try {

  
        const url = `${config.oat_api_url}/assessments/set_for_review_by_completed/${assessment_id}/${reviewer_id}/${asmnt_review_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          // body: JSON.stringify({ assessment_state: selectedStatus }), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const res_data = await response.json();
        

        dispatch({
          type: 'FINISH_ASSESMENT_REVIEWS',
          payload: { 
            finish_assesment_review: res_data 
          },
        });

        return res_data

      } catch (error) {
        console.error('Error set for review the assessment:', error);
      } finally {
        dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: false } });

        setTimeout(() => {
          dispatch({
            type: 'FINISH_ASSESMENT_REVIEWS',
            payload: { 
              finish_assesment_review: null 
            },
          });
        }, 2000);
      }
    },
    []
  );

  const setPaperToPublish = useCallback(
    async (assessment_id,asmnt_review_id,user_id,type) => {

      dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: true } });
  
      try {

  
        const url = `${config.oat_api_url}/assessments/set_paper_to_publish/${assessment_id}/${asmnt_review_id}/${user_id}`;
  
        const requestOptions = {
          method: 'POST',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          body: JSON.stringify({ type: type }), 
        };
  
        const response = await fetch(url, requestOptions);
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const res_data = await response.json();
    
        dispatch({
          type: 'FINALIZE_PAPER',
          payload: { 
            finalize_paper: res_data 
          },
        });
        
        return res_data

      } catch (error) {
        console.error('Error set assessment to publish:', error);
      } finally {
        dispatch({ type: 'SET_ADD_UPDATE_REVIEW_LOADING', payload: { review_loading: false } });
      }
    },
    []
  );

  const fetchStudentDashboardData = useCallback(
    async (user_id) => {
     
      if (state.student_dashboard_initial_loading) {
        dispatch({ 
          type: 'SET_STUDENT_DASHBOARD_DATA_LOADING', 
          payload: { student_dashboard_data_loading: true } 
        });
      }
      else{
        dispatch({ 
          type: 'SET_STUDENT_DASHBOARD_DATA_LOADING', 
          payload: { student_dashboard_data_loading: true } 
        });
      }

      try {
        const url = `${config.oat_api_url}/manage/tree-main-hierarchy-nodes/get-student-dashboard-content/${user_id}`;
        const requestOptions = {
          method: 'GET',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };

        const response = await fetch(url, requestOptions);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res_data = await response.json();
        
        dispatch({
          type: 'SET_STUDENT_DASHBOARD_DATA',
          payload: { 
            student_dashboard_data: res_data 
          },
        });

        if (state.student_dashboard_initial_loading) {
          dispatch({
            type: 'SET_STUDENT_DASHBOARD_INITIAL_LOADING',
            payload: { student_dashboard_initial_loading: false },
          });
        }
        dispatch({ 
          type: 'SET_STUDENT_DASHBOARD_DATA_LOADING', 
          payload: { student_dashboard_data_loading: false } 
        });

      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        // Only reset loading state if it's the initial load
        if (state.student_dashboard_initial_loading) {
          dispatch({ 
            type: 'SET_STUDENT_DASHBOARD_DATA_LOADING', 
            payload: { student_dashboard_data_loading: false } 
          });
        }
        dispatch({ 
          type: 'SET_STUDENT_DASHBOARD_DATA_LOADING', 
          payload: { student_dashboard_data_loading: false } 
        });
      }
    },
    [state.student_dashboard_initial_loading]
  );

  const fetchParentDashboardData = useCallback(
    async (student_ids) => {
     
      if (state.parent_dashboard_initial_loading) {
        dispatch({ 
          type: 'SET_PARENT_DASHBOARD_DATA_LOADING', 
          payload: { parent_dashboard_data_loading:true } 
        });
      }
      else{
        dispatch({ 
          type: 'SET_PARENT_DASHBOARD_DATA_LOADING', 
          payload: { parent_dashboard_data_loading: true } 
        });
      }

      try {
        const idString = Array.isArray(student_ids) ? student_ids.join(',') : student_ids;
        const url = `${config.oat_api_url}/manage/tree-main-hierarchy-nodes/get-parent-dashboard-content/${idString}`;
        const requestOptions = {
          method: 'GET',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };

        const response = await fetch(url, requestOptions);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res_data = await response.json();
        
        dispatch({
          type: 'SET_PARENT_DASHBOARD_DATA',
          payload: { 
            parent_dashboard_data: res_data 
          },
        });

        if (state.parent_dashboard_initial_loading) {
          dispatch({
            type: 'SET_PARENT_DASHBOARD_INITIAL_LOADING',
            payload: { parent_dashboard_initial_loading: false },
          });
        }
        dispatch({ 
          type: 'SET_PARENT_DASHBOARD_DATA_LOADING', 
          payload: { parent_dashboard_data_loading: false } 
        });

      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        // Only reset loading state if it's the initial load
        if (state.parent_dashboard_initial_loading) {
          dispatch({ 
            type: 'SET_PARENT_DASHBOARD_DATA_LOADING', 
            payload: { parent_dashboard_data_loading: false } 
          });
        }
        dispatch({ 
          type: 'SET_PARENT_DASHBOARD_DATA_LOADING', 
          payload: { parent_dashboard_data_loading: false } 
        });
      }
    },
    [state.parent_dashboard_initial_loading]
  );

  const fetchAssesorTeacherDashboardData = useCallback(
    async () => {
     
      if (state.assesor_dashboard_initial_loading) {
        dispatch({ 
          type: 'SET_ASSESOR_DASHBOARD_DATA_LOADING', 
          payload: { assesor_dashboard_initial_loading:true } 
        });
      }
      else{
        dispatch({ 
          type: 'SET_ASSESOR_DASHBOARD_DATA_LOADING', 
          payload: { assesor_dashboard_data_loading: true } 
        });
      }

      try {
        const url = `${config.oat_api_url}/manage/tree-main-hierarchy-nodes/get-assesor-dashboard-content`;
        const requestOptions = {
          method: 'GET',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };

        const response = await fetch(url, requestOptions);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res_data = await response.json();
        
        dispatch({
          type: 'SET_ASSESOR_DASHBOARD_DATA',
          payload: { 
            assesor_dashboard_data: res_data 
          },
        });

        if (state.assesor_dashboard_initial_loading) {
          dispatch({
            type: 'SET_ASSESOR_DASHBOARD_INITIAL_LOADING',
            payload: { assesor_dashboard_initial_loading: false },
          });
        }
        dispatch({ 
          type: 'SET_ASSESOR_DASHBOARD_DATA_LOADING', 
          payload: { assesor_dashboard_data_loading: false } 
        });

      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        // Only reset loading state if it's the initial load
        if (state.assesor_dashboard_initial_loading) {
          dispatch({ 
            type: 'SET_ASSESOR_DASHBOARD_DATA_LOADING', 
            payload: { assesor_dashboard_data_loading: false } 
          });
        }
        dispatch({ 
          type: 'SET_ASSESOR_DASHBOARD_DATA_LOADING', 
          payload: { assesor_dashboard_data_loading: false } 
        });
      }
    },
    [state.assesor_dashboard_initial_loading]
  );

  const fetchReviewerDashboardData = useCallback(
    async (user_id) => {
     
      if (state.reviewer_dashboard_initial_loading) {
        dispatch({ 
          type: 'SET_REVIEWER_DASHBOARD_DATA_LOADING', 
          payload: { reviewer_dashboard_data_loading: true } 
        });
      }
      else{
        dispatch({ 
          type: 'SET_REVIEWER_DASHBOARD_DATA_LOADING', 
          payload: { reviewer_dashboard_data_loading: true } 
        });
      }

      try {
        const url = `${config.oat_api_url}/manage/tree-main-hierarchy-nodes/get-reviewer-dashboard-content/${user_id}`;
        const requestOptions = {
          method: 'GET',
          headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };

        const response = await fetch(url, requestOptions);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res_data = await response.json();
        
        dispatch({
          type: 'SET_REVIEWER_DASHBOARD_DATA',
          payload: { 
            reviewer_dashboard_data: res_data 
          },
        });

        if (state.reviewer_dashboard_initial_loading) {
          dispatch({
            type: 'SET_REVIEWER_DASHBOARD_DATA_INITIAL_LOADING',
            payload: { reviewer_dashboard_initial_loading: false },
          });
        }
        dispatch({ 
          type: 'SET_REVIEWER_DASHBOARD_DATA_LOADING', 
          payload: { reviewer_dashboard_data_loading: false } 
        });

      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        // Only reset loading state if it's the initial load
        if (state.reviewer_dashboard_initial_loading) {
          dispatch({ 
            type: 'SET_REVIEWER_DASHBOARD_DATA_LOADING', 
            payload: { reviewer_dashboard_data_loading: false } 
          });
        }
        dispatch({ 
          type: 'SET_REVIEWER_DASHBOARD_DATA_LOADING', 
          payload: { reviewer_dashboard_data_loading: false } 
        });
      }
    },
    [state.reviewer_dashboard_initial_loading]
  );

   const fetchAssessmentFilterdData = useCallback(async () => {

    const cacheKey = "assessment_filter_metadata";

    dispatch({
        type: 'SET_ASSESSMENT_FILTER_DATA_LOADING',
        payload: { assessment_filter_data_loading: true }
    });

    try {
        const cachedData = sessionStorage.getItem(cacheKey);
        if (cachedData) {
          const parsedData = JSON.parse(cachedData);
           dispatch({
                type: 'SET_ASSESSMENT_FILTER_DATA',
                payload: {
                    assessment_filter_data: parsedData
                },
            });

            return;
        }
        const url = `${config.oat_api_url}/assessments/get-all-meta-data-for-filter`;
        const requestOptions = {
            method: 'GET',
            headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };

        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res_data = await response.json();

        if (res_data?.data) {

           
            sessionStorage.setItem(
                cacheKey,
                JSON.stringify(res_data.data)
            );

            dispatch({
                type: 'SET_ASSESSMENT_FILTER_DATA',
                payload: {
                    assessment_filter_data: res_data.data
                },
            });
        }

    } catch (error) {
        console.error('Error fetching dashboard data:', error);

    } finally {

        dispatch({
            type: 'SET_ASSESSMENT_FILTER_DATA_LOADING',
            payload: { assessment_filter_data_loading: false }
        });
    }

}, []);

  // ----------------------------------------------------------------------


  const memoizedValue = useMemo(
    () => ({
      loading: state.loading,
      myAssessments: state.myAssessments,
      totalCount: state.totalCount,
      gradeCounts: state.gradeCounts,
      subjectCounts: state.subjectCounts,
      languageCounts: state.languageCounts,
      examCategoryCounts: state.examCategoryCounts,
      reviewerCount: state.reviewerCount,
      sourceCounts: state.sourceCounts,
      authorCounts: state.authorCounts,
      createdByCounts: state.createdByCounts,
      categoryCounts: state.categoryCounts,
      difficultyCounts: state.difficultyCounts,
      chapterCounts: state.chapterCounts,
      yearCounts: state.yearCounts,
      termCounts: state.termCounts,
      statusCounts: state.statusCounts,
      assmnt_content:state.assmnt_content,
      asmnt_details:state.asmnt_details,
      assmnt_loading: state.assmnt_loading,
      questionContents: state.questionContents,
      assesment_review: state.assesment_review,
      assessment_operation: state.assessment_operation,
      assesment_review_state: state.assesment_review_state,
      review_loading: state.review_loading,
      assesment_status_types: state.assesment_status_types,
      finish_assesment_review: state.finish_assesment_review,
      finalize_paper: state.finalize_paper,
      comment_loading: state.comment_loading,
      assesment_sub_review_state: state.assesment_sub_review_state,
      sub_review_loading: state.sub_review_loading,
      assesment_mark_as_review_state: state.assesment_mark_as_review_state,
      mark_as_review_loading : state.mark_as_review_loading,
      assign_reviewer: state.assign_reviewer,
      assign_operator: state.assign_operator,
      assignment_background_loading:state.assignment_background_loading,
      addTemplate: state.addTemplate,
      templates: state.templates,
      updateTemplate: state.updateTemplate,
      templateMetaData:state.templateMetaData,
      addSection:state.addSection,
      sections:state.sections,
      updateSection: state.updateSection,
      addPart: state.addPart,
      parts: state.parts,
      updatePart: state.updatePart,
      operation_comment_loading: state.operation_comment_loading,
      student_dashboard_data: state.student_dashboard_data,
      student_dashboard_data_loading: state.student_dashboard_data_loading,
      student_dashboard_initial_loading: state.student_dashboard_initial_loading,
      parent_dashboard_data: state.parent_dashboard_data,
      parent_dashboard_data_loading: state.parent_dashboard_data_loading,
      parent_dashboard_initial_loading: state.parent_dashboard_initial_loading,
      assesor_dashboard_data:state.assesor_dashboard_data,
      assesor_dashboard_data_loading:state.assesor_dashboard_data_loading,
      assesor_dashboard_initial_loading:state.assesor_dashboard_initial_loading,

      reviewer_dashboard_initial_loading: state.reviewer_dashboard_initial_loading,
      reviewer_dashboard_data_loading: state.reviewer_dashboard_data_loading,
      reviewer_dashboard_data: state.reviewer_dashboard_data,

      assessment_filter_data_initial_loading:state.assessment_filter_data_initial_loading,
      assessment_filter_data_loading:state.assessment_filter_data_loading,
      assessment_filter_data: state.assessment_filter_data,

      fetchAllMyAssessments,
      fetchLoadAssesmentQuestionById,
      getAllQuestionContents,
      addUpdateReviewForAssesment,
      fetchAllReviewComments,
      fetchAllOperationComments,
      finishPaperReview,
      setReview,
      finishPaperOperation,
      finalizePaper,
      addSubReviewForAssesment,
      addOperationCommentForAssessment,
      markAsReviewForQuestion,
      setLoadings,
      assignReviewer,
      assignOperator,
      changeAssignedReviewer,
      changeAssignedOperator,
      fetchAllTemplates,
      createTemplate,
      handleUpdateTemplate,
      createSection,
      fetchTemplateMetaData,
      fetchAllSections,
      handleUpdateSection,
      createPart,
      fetchAllParts,
      handleUpdatePart,
      finishPaperReviewByCompleted,
      setPaperToPublish,
      fetchStudentDashboardData,
      fetchParentDashboardData,
      fetchAssesorTeacherDashboardData,
      fetchReviewerDashboardData,
      fetchAssessmentFilterdData
    }), [
      state,
      state.loading,
      state.myAssessments,
      state.gradeCounts,
      state.subjectCounts,
      state.languageCounts,
      state.examCategoryCounts,
      state.reviewerCount,
      state.sourceCounts,
      state.authorCounts,
      state.createdByCounts,
      state.categoryCounts,
      state.difficultyCounts,
      state.chapterCounts,
      state.yearCounts,
      state.termCounts,
      state.statusCounts,
      state.assmnt_content,
      state.asmnt_details,
      state.assmnt_loading,
      state.questionContents,
      state.assesment_review,
      state.assessment_operation,
      state.assesment_review_state,
      state.review_loading,
      state.assesment_status_types,
      state.finish_assesment_review,
      state.finalize_paper,
      state.comment_loading,
      state.assesment_sub_review_state,
      state.sub_review_loading,
      state.mark_as_review_loading,
      state.assesment_mark_as_review_state,
      state.assign_reviewer,
      state.assign_operator,
      state.assignment_background_loading,
      state.templates,
      state.addTemplate,
      state.updateTemplate,
      state.templateMetaData,
      state.addSection,
      state.sections,
      state.updateSection,
      state.addPart,
      state.parts,
      state.updatePart,
      state.operation_comment_loading,
      state.student_dashboard_data,
      state.student_dashboard_data_loading,
      state.student_dashboard_initial_loading,
      state.parent_dashboard_data,
      state.parent_dashboard_data_loading,
      state.parent_dashboard_initial_loading,
      state.assesor_dashboard_data,
      state.assesor_dashboard_data_loading,
      state.assesor_dashboard_initial_loading,
      state.reviewer_dashboard_initial_loading,
      state.reviewer_dashboard_data_loading,
      state.reviewer_dashboard_data,
      state.assessment_filter_data_initial_loading,
      state.assessment_filter_data_loading,
      state.assessment_filter_data,

      fetchAllMyAssessments,
      fetchLoadAssesmentQuestionById,
      getAllQuestionContents,
      addUpdateReviewForAssesment,
      fetchAllReviewComments,
      fetchAllOperationComments,
      finishPaperReview,
      setReview,
      finishPaperOperation,
      finalizePaper,
      addSubReviewForAssesment,
      addOperationCommentForAssessment,
      markAsReviewForQuestion,
      setLoadings,
      assignReviewer,
      assignOperator,
      changeAssignedReviewer,
      changeAssignedOperator,
      fetchAllTemplates,
      createTemplate,
      handleUpdateTemplate,
      createSection,
      fetchTemplateMetaData,
      fetchAllSections,
      handleUpdateSection,
      createPart,
      fetchAllParts,
      handleUpdatePart,
      finishPaperReviewByCompleted,
      setPaperToPublish,
      fetchStudentDashboardData,
      fetchParentDashboardData,
      fetchAssesorTeacherDashboardData,
      fetchReviewerDashboardData,
      fetchAssessmentFilterdData
  ]);

      return (
        <MainContext.Provider value={memoizedValue}>
          {children}
        </MainContext.Provider>
      );
}

MainContextProvider.propTypes = {
  children: PropTypes.node,
};


